import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  PxyQuery: {
    ...apiFuns.genStandard("pxyQuery", "/api/md"),
    execSql:(para)=> post('/api/md/pxyQuery/exec', para)
  },
  Role: apiFuns.genStandard("role", "/api/md"),
  PxyDb: {
    ...apiFuns.genStandard("pxyDb", "/api/md"),
    testSql:(para)=> post('/api/md/pxyDb/test', para),
  },
  exec: (url, para) => post(url, para)
};

export default api;
